import React from 'react';
import {useTranslation} from 'react-i18next';
import {PageTitle} from '@app/components/common/PageTitle/PageTitle';
import {PageLayout} from '@app/components/layouts/PageLayout/PageLayout';

import {IndustryCalculatorForm} from '@app/components/calculators/forms/IndustryCalculatorForm';
import {useParams} from 'react-router-dom';

const IndustryCalculatorPage: React.FC = () => {
  const {t} = useTranslation();
  const {country} = useParams();

  const getCountry = () => {
    switch (country) {
      case 'rs':
        return t('countries.serbia');
      case 'global':
        return t('countries.global');
      default:
        return t('countries.global');
    }
  };

  return (
    <>
      <PageTitle>{t('industryCalculator.pageHeader')}</PageTitle>
      <PageLayout
        title={t('industryCalculator.pageHeader') + ' - ' + getCountry()}
        backButtonLink={process.env.REACT_APP_ROUTE_HOME}
      >
        <IndustryCalculatorForm />
      </PageLayout>
    </>
  );
};

export default IndustryCalculatorPage;
